export enum ShopType {
  Online,
  Offline,
  IndVATNumber
}
